import { useEffect, useState } from 'react';
import { db } from '../utils/firebase';
import { collection, getDocs } from 'firebase/firestore';
import './Home.css';

export default function Home() {
  const [works, setWorks] = useState({});
  const [selectedMedia, setSelectedMedia] = useState(null);

  useEffect(() => {
    const fetchWorks = async () => {
      const snapshot = await getDocs(collection(db, 'portfolio'));
      const grouped = {};

      snapshot.forEach(doc => {
        const data = doc.data();
        const year = data.year || 'Unknown';

        if (!grouped[year]) grouped[year] = [];
        grouped[year].push(data);
      });

      setWorks(grouped);
    };

    fetchWorks();
  }, []);

  return (
    <div className="home">
      <h1 className="home-title">Showcase</h1>

      {Object.keys(works)
        .sort((a, b) => b - a)
        .map(year => (
          <div key={year} className="year-section">
            <h2 className="year-heading">{year}</h2>

            <div className="portfolio-column">
              {works[year].map((item, index) => (
                <div key={index} className="portfolio-item">
                  <h3>{item.title}</h3>
                  <p>{item.description}</p>

                  <div className="media-scroll">
                    {item.media
                      ?.slice()
                      .sort((a, b) => {
                        if (a.type === 'video' && b.type === 'image') return -1;
                        if (a.type === 'image' && b.type === 'video') return 1;
                        return 0;
                      })
                      .map((media, i) =>
                        media.type === 'image' ? (
                          <img
                            key={i}
                            src={media.url}
                            alt={`media-${i}`}
                            className="media-thumb"
                            loading="lazy"
                            decoding="async"
                            onLoad={e => e.target.classList.add('loaded')}
                            onError={e => e.target.classList.add('error')}
                            onClick={() => setSelectedMedia(media)}
                          />
                        ) : (
                          <video
                            key={i}
                            src={media.url}
                            className="media-thumb"
                            controls
                            preload="none"
                            onClick={() => setSelectedMedia(media)}
                          />
                        )
                      )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}

      {selectedMedia && (
        <div className="media-modal" onClick={() => setSelectedMedia(null)}>
          {selectedMedia.type === 'image' ? (
            <img src={selectedMedia.url} alt="" />
          ) : (
            <video src={selectedMedia.url} controls autoPlay />
          )}
        </div>
      )}
    </div>
  );
}